import styled, { css } from 'styled-components';

const Icon = styled.i.attrs((props) => ({
  className: `icon-${props.icon || props.type} ${
    props.size ? `icon--${props.size}` : ''
  }`,
}))`
  &&& {
    ${({ color }) =>
      color &&
      css`
        color: var(--${color});
      `}
  }
`;

export default Icon;
